import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { BudgetEntity } from "./budget.entity";
import { BudgetController } from "./budget.controller";
import { BudgetService } from "./budget.service";


@Module({
    imports: [
        TypeOrmModule.forFeature([BudgetEntity]),
    ],
    controllers: [BudgetController],
    providers: [BudgetService, ApplicationExceptionHandler]
})
export class BudgetModule {

}